const es = {
  common: {
    // Indicador global de datos simulados (MockDataBadge). Ver docs/contexto/decisiones.md D-8.
    mockData: 'Datos de demostración',
    mockDataHint: 'El servicio de Reconocimiento aún no está desplegado: esta pantalla se está sirviendo con datos simulados dentro de la propia aplicación.',
    loading: 'Cargando...',
    error: 'Error',
    documentNotAvailable: 'Este documento no está disponible por ahora. Puede deberse a tu idioma o a tu unidad; si el problema continúa, contacta a tu administrador.',
    sessionExpiredMessage: 'Tu sesión expiró. Guarda lo que puedas y vuelve a iniciar sesión.',
    reload: 'Iniciar sesión',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    close: 'Cerrar',
    download: 'Descargar',
    confirm: 'Confirmar',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    yes: 'Sí',
    no: 'No',
    back: 'Atrás',
    next: 'Siguiente',
    submit: 'Enviar',
    darkMode: 'Modo oscuro',
    lightMode: 'Modo claro',
    languageMenuTitle: 'Cambiar idioma',
    logout: 'Cerrar sesión',
    pagerShow: 'Mostrar',
    pagerPerPage: 'por página',
    pagerOf: 'de',
    viewCards: 'Vista tarjetas',
    viewList: 'Vista lista',
    collapse: 'Colapsar',
    expand: 'Expandir',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    retry: 'Reintentar',
    errorBoundaryTitle: 'Algo salió mal',
    errorGeneric: 'Ocurrió un error inesperado. Por favor intenta de nuevo.',
    expandModal: 'Expandir en modal',
    resetToGlobal: 'Restablecer a global',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Home',
    growth: 'Crecimiento',
    admin: 'Administración',
    executive: 'Ejecutivo',
    analytics: 'Analytics',
    switchDemoProfile: 'Cambiar perfil de demo',
    mobileNav: 'Navegación principal',
    fundamentals: 'Fundamentales',
    usersAdmin: 'Administradores',
    recognitionSection: 'Reconocimientos',
    language: 'Idioma',
    collapseMenu: 'Contraer menú',
    expandMenu: 'Expandir menú',
  },
  roles: {
    employee: 'Empleado',
    adminOU: 'Admin OU Pulso',
    adminGlobal: 'Admin General',
    adminPulso: 'Admin Pulso',
    adminBrillamos: 'Admin Brillamos',
    adminOUBrillamos: 'Admin OU Brillamos',
  },
  access: {
    noModulesTitle: 'Sin acceso a ningún módulo',
    noModulesDesc: 'Tu cuenta no tiene habilitado Pulso ni Reconocimiento. Solicita el acceso al administrador de tu organización.',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Encuestas pendientes',
    pending: 'Pendiente',
    completed: 'Completada',
    expired: 'Expirada',
    submit: 'Enviar evaluación',
    skip: 'Omitir',
    noObs: 'Sin observación',
    meeting: 'Reunión',
    duration: 'Duración',
    participants: 'Participantes',
    simulateMeeting: 'Simular fin de junta',
    thankYou: '¡Gracias por tu evaluación!',
    evaluating: 'Evaluando a',
    of: 'de',
    question: 'Pregunta',
    selectResponse: 'Selecciona una respuesta',
    nps: {
      question: '¿Qué tan probable es que recomiendas trabajar con esta persona?',
      detractor: 'Detractor',
      passive: 'Pasivo',
      promoter: 'Promotor',
    },
    evaluateNow: 'Evaluar ahora',
    postpone: 'Después',
    expires: 'Expira',
    noSurveysPending: '¡Sin encuestas pendientes! Buen trabajo.',
    weekCompleted: 'sem.',
    likert: {
      always: 'Siempre',
      usually: 'Casi siempre',
      sometimes: 'A veces',
      rarely: 'Casi nunca',
      notObservable: 'No observable',
    },
    questions: {
      listenedActivelyText: '¿Esta persona escuchó activamente y mostró interés genuino?',
      sharedKnowledgeText: '¿Compartió conocimiento o experiencias relevantes durante la sesión?',
    },
    completeSubtitle: 'Tu retroalimentación ayuda a fortalecer la cultura del equipo.',
    backToHome: 'Volver al inicio',
    // Home page
    greetingMorning: 'Buenos días',
    greetingAfternoon: 'Buenas tardes',
    greetingEvening: 'Buenas noches',
    pendingCountPre: 'Tienes',
    pendingCountSingular: 'encuesta pendiente',
    pendingCountPlural: 'encuestas pendientes',
    allDoneTitle: '¡Todo al día!',
    allDoneSubtitle: 'No tienes encuestas pendientes. Después de tu próxima junta aparecerán aquí.',
    omit: 'Omitir',
    omitSurvey: 'Omitir encuesta',
    submitSuccess: 'Respuestas enviadas',
    submitError: 'Error al enviar — intenta de nuevo',
    omitSuccess: 'Encuesta omitida',
    omitError: 'Error al omitir — intenta de nuevo',
    unavailableError: 'Esta encuesta ya no está disponible',
    kpi: {
      answered: 'Contestadas',
      omitted: 'Omitidas',
      streak: 'Racha',
      participation: 'Participación',
    },
    growth: {
      title: 'Tu crecimiento te espera',
      message: 'Revisa tus resultados, tendencias y áreas de desarrollo en tu panel de crecimiento.',
      cta: 'Ver mi crecimiento',
    },
    recognition: {
      title: 'Brillamos Juntos',
      message: 'Reconoce a tus colegas y celebra sus logros en el Programa de Reconocimiento.',
      cta: 'Ir a Reconocimiento',
    },
    tips: {
      title: 'Tips para ti',
      based: 'Basados en tu score promedio',
      empty: 'Completa más encuestas para ver tips personalizados',
      reconocer: 'Para reconocer',
      crecer: 'Para crecer',
      tipOfDay: 'Tip del día',
    },
  },
  safe: {
    title: 'Mi Crecimiento',
    subtitle: 'Tu desarrollo cultural en Sigma',
    sectionName: 'Mi retroalimentación',
    surveysAnswered: 'Encuestas contestadas',
    score: 'Tu Score',
    evolution: 'Tu evolución',
    evolutionSub: 'Tu camino personal — solo tú, sin comparaciones',
    radarTitle: 'Tu perfil por Fundamental',
    radarSub: 'Tú hoy vs tú hace 3 meses — tu propio progreso',
    fundamentals: 'Fundamentales',
    fundamentalsChart: 'Tu retroalimentación por Fundamental',
    fundamentalsChartSub: 'Dónde estás en cada uno — click en cualquier barra para ver detalle',
    behaviors: 'Comportamientos',
    kudos: 'Reconocimientos',
    kudosTitle: 'Para Reconocer — lo que más aportas',
    kudosSub: 'Lo que tus compañeros observan más de ti este mes',
    actions: 'Plan de acción',
    omissions: 'Omisiones',
    period: 'Período',
    received: 'Recibidas',
    sent: 'Enviadas',
    areaAverage: 'Promedio área',
    today: 'Hoy (últimos {{days}} días)',
    threeMonthsAgo: 'Hace 3 meses (ventana de {{days}} días)',
    detail: 'Detalle',
    profileTitle: 'Tu perfil cultural en palabras',
    profileSub: 'Comportamientos, no números',
    basedOn: 'Basado en {{count}} retroalimentaciones anónimas',
    level0: 'Inicio',
    level1: 'En desarrollo',
    level2: 'Consistente',
    level3: 'Referente',
    level0desc: 'Espera que otros resuelvan los problemas o eliminen los obstáculos.',
    level1desc: 'Intenta abordar los obstáculos, pero se rinde rápidamente o escala prematuramente.',
    level2desc: 'Toma la iniciativa para eliminar obstáculos y encontrar soluciones que impulsen el avance.',
    level3desc: 'Inspira a otros a tomar la iniciativa y crea un entorno donde desatascarse es una responsabilidad compartida.',
    levelAbbr0: 'Inicio',
    levelAbbr1: 'En des.',
    levelAbbr2: 'Consiste.',
    levelAbbr3: 'Referente',
    todayLabel: 'Hoy',
    pointsInMonths: 'puntos en {{n}} meses',
    monthsWithFeedback: 'meses con feedback',
    journeyLoading: 'Cargando tu evolución…',
    journeyEmpty: 'Aún no hay suficiente historial para dibujar tu evolución. Necesitas al menos dos meses con retroalimentación.',
    journeyChartLabel: 'Evolución de tu promedio mes a mes',
    thisMonth: 'este mes',
    headingToLevel: 'Rumbo a {{level}}',
    maxLevel: '¡Nivel máximo!',
    narrativeStrength: 'Lo que más aportas y merece reconocimiento es <strong>{{fund}}</strong> — estás en nivel <strong>{{level}}</strong>.',
    narrativeConsistency: 'También muestras consistencia en {{others}}.',
    narrativeProgress: 'En los últimos 3 meses has avanzado — tu perfil muestra crecimiento.',
    narrativeStable: 'Tu perfil se ha mantenido estable en los últimos 3 meses — eso habla de consistencia.',
    narrativeVariation: 'Tu perfil ha variado un poco en los últimos meses. Las variaciones son normales y no definen tu trayectoria.',
    narrativeNextLevel: 'Tu siguiente nivel para crecer está en <strong>{{fund}}</strong>. El siguiente paso es llegar a nivel {{level}} — más abajo te sugerimos una acción concreta.',
    act01: 'Reconocimiento — cómo te ven',
    act02: 'Progreso — cómo has evolucionado',
    act03: 'Dirección — tu siguiente paso',
    reinforces: 'REFUERZA',
    tryToday: 'Lo intento hoy',
    committed: '¡Me comprometo hoy!',
    defaultChallenge: 'Practica un fundamental hoy',
    defaultChallengeDesc: 'Elige una micro-acción y ponla en práctica en tu próxima reunión.',
    clickDetail: 'Click para detalle',
    nextLevel: 'SIGUIENTE NIVEL',
    growthTitle: 'PARA SEGUIR CRECIENDO',
    growthSub: 'Recomendaciones basadas en tu retroalimentación',
    feedbacks: 'retroalimentaciones',
    peers: 'colegas',
    givenTitle: 'Mi participación dando retroalimentación',
    givenSub: 'Retroalimentaciones que has compartido este mes',
    footerPrivacy: 'Todo el feedback es anónimo. Nadie puede ver quién te lo dio. Esta vista es solo tuya.',
    footerHeart: 'Recuerda: el feedback es un regalo. Estos datos reflejan momentos en reuniones, no definen quién eres.',
    personSingular: 'persona',
    personsPlural: 'personas',
    trend: {
      up: 'Tu perfil muestra crecimiento',
      down: 'Pequeña variación — es normal',
      stable: 'Perfil estable — eso es consistencia',
    },
    empty: {
      title: 'Conoce los Fundamentales',
      desc: 'Aún no tienes suficiente retroalimentación para mostrar tu dashboard. Mientras tanto, explora los comportamientos que medimos.',
      hint: 'Tu dashboard se activa cuando hayas respondido más de 3 encuestas y recibido al menos 3 evaluaciones de tus pares.',
      answeredLabel: 'Encuestas que has respondido',
      receivedLabel: 'Evaluaciones que has recibido',
    },
    error: {
      title: 'No pudimos cargar tu dashboard',
      desc: 'Hubo un problema al obtener tu información. Vuelve a intentarlo; si el problema sigue, avisa al equipo de soporte.',
      retry: 'Reintentar',
      retrying: 'Reintentando…',
    },
    given: {
      loading: 'Cargando tu historial…',
      empty: 'Todavía no has respondido ninguna encuesta.',
      loadError: 'No pudimos cargar tu historial de encuestas respondidas.',
      completed: 'Completada',
      peopleCount_one: '{{count}} persona',
      peopleCount_other: '{{count}} personas',
    },
    celebration: {
      default: 'Tu manera de trabajar deja huella en quienes te rodean.',
      learner: 'Tu curiosidad y tu apertura al aprendizaje inspiran a quienes trabajan contigo.',
      player_owner: 'Tomas responsabilidad sin que nadie te lo pida, y eso marca el ritmo del equipo.',
      psychological_safety: 'Con tu forma de escuchar, la gente se atreve a decir lo que piensa.',
      collaborate_effectively: 'Cuando tú colaboras, el trabajo de todos avanza más rápido.',
      quality_of_work: 'Tu cuidado por el detalle levanta el estándar de lo que entrega el equipo.',
      make_others_successful: 'Te ocupas de que los demás brillen, y el equipo entero lo nota.',
      explore_experiment: 'Tu disposición a probar cosas nuevas abre caminos que nadie había visto.',
    },
    popup: {
      peersOpined: 'colegas opinaron',
      evaluationsCount: '{{count}} evaluaciones',
      subbehaviors: 'Sub-comportamientos',
      dailyHabits: 'Hábitos diarios',
      monthlyHistory: 'Evolución mensual',
      distribution: 'Distribución de retroalimentaciones',
      behaviorScale: 'Escala de comportamiento',
      you: 'Tú',
    },
  },
  admin: {
    title: 'Administración',
    menu: {
      general: 'Admin General',
      pulso: 'Pulso',
      brillamos: 'Brillamos',
    },
    roleAdminGeneral: 'Admin General',
    roleAdminPulso: 'Admin Pulso',
    roleAdminOUPulso: 'Admin OU Pulso',
    roleAdminBrillamos: 'Admin Brillamos',
    roleAdminOUBrillamos: 'Admin OU Brillamos',
    roleEmployee: 'Empleado',
    greetingMorning: 'Buenos días',
    greetingAfternoon: 'Buenas tardes',
    greetingEvening: 'Buenas noches',
    // Main tabs
    surveys: 'Encuestas',
    templates: 'Templates',
    analyticsTab: 'Analytics',
    rulesTab: 'Reglas de Negocio',
    users: 'Usuarios',
    notifications: 'Notificaciones',
    // Surveys tab
    surveysTitle: 'Gestión de Encuestas',
    searchSurvey: 'Buscar encuesta...',
    trash: 'Papelera',
    newSurvey: 'Nueva Encuesta',
    fundamentalsTab: 'Fundamentales',
    customTab: 'Personalizadas',
    colName: 'Nombre',
    colTitle: 'Título',
    colDescription: 'Descripción',
    colQuestions: 'Preguntas',
    colStatus: 'Estado',
    colAudience: 'Audiencia',
    sectionCrashed: "No se pudo mostrar esta sección. Vuelve a intentarlo o elige otra.",
    colFrequency: 'Frecuencia',
    freqDaily: 'Diaria',
    freqWorkdays: 'Días laborales',
    freqWeekly: 'Semanal · {{day}}',
    freqCustom: '{{count}} días/semana',
    freqNone: '—',
    colFeedback: 'Retroalimentaciones',
    colPeriod: 'Periodo',
    colActions: 'Acciones',
    colCreatedBy: 'Creada por',
    creatorUnknown: 'Desconocido',
    colEmail: 'Email',
    colOU: 'OU',
    colUses: 'usos',
    statusActive: 'Activa',
    statusPaused: 'Pausada',
    statusInactive: 'Inactiva',
    statusPending: 'Pendiente',
    anonymous: 'Anónima',
    duplicate: 'Duplicar',
    exportExcelTip: 'Exportar Excel',
    // Templates tab
    templatesTitle: 'Templates de Encuestas',
    tipsTab: 'Tips',
    actionsTab: 'Acciones',
    catalogTab: 'Catálogos',
    createTemplate: 'Crear template',
    typeFundamental: 'Fundamental',
    typeCustom: 'Personalizada',
    placeholderTips: 'Tips — Módulo de consejos para colaboradores',
    placeholderActions: 'Acciones — Planes de acción post-encuesta',
    placeholderCatalog: 'Catálogo de Fundamentales — Biblioteca de comportamientos evaluables',
    // Templates catalog controls
    tplSearchPlaceholder: 'Buscar template…',
    tplFilterAll: 'Todos los tipos',
    tplNoResults: 'No hay templates con ese criterio',
    // Tips sub-tab
    tipsTitle: 'Tips de Feedback',
    tipsSearchPlaceholder: 'Buscar tip…',
    tipsAllFundamentals: 'Todos los Fundamentales',
    tipsAllTypes: 'Todos los tipos',
    tipTypeReconocer: 'Para Reconocer',
    tipTypeCrecer: 'Para Crecer',
    tipsNoResults: 'No hay tips con ese criterio',
    surveysNoResults: 'No hay encuestas con ese criterio',
    surveysError: 'Error al obtener las encuestas. Intente más tarde.',
    createTip: 'Crear tip',
    // Acciones sub-tab
    actionsTitle: 'Acciones de Crecimiento',
    actionsSearchPlaceholder: 'Buscar acción…',
    actionsNoResults: 'No hay acciones con ese criterio',
    createAction: 'Crear acción',
    // Catálogo sub-tab
    catalogTitle: 'Catálogo de Fundamentales',
    catalogFundamentals: 'Fundamentales',
    catalogBehaviors: 'Behaviors',
    catalogAddFundamental: 'Agregar Fundamental',
    catalogAddBehavior: 'Agregar Daily Habit',
    catalogSearchFundamental: 'Buscar fundamental…',
    catalogSearchBehavior: 'Buscar daily habit…',
    catalogNoBehaviors: 'Sin daily habits para este fundamental',
    catalogSelectFundamental: 'Selecciona un Fundamental de la lista',
    // OUs sub-tab
    ousTab: 'OUs',
    ousTitle: 'Unidades Organizativas',
    ousSubtitle: 'Gestiona las OUs raíz del tenant',
    ousSearchPlaceholder: 'Buscar OU…',
    ousNoResults: 'No hay OUs con ese criterio',
    createOU: 'Crear OU',
    editOU: 'Editar OU',
    deleteOU: 'Eliminar OU',
    deleteOUConfirm: '¿Eliminar la OU "{{name}}"? Esta acción no se puede deshacer.',
    ouDescription: 'Descripción',
    ouAdminUser: 'Admin OU (AAD User ID)',
    ouType: 'Tipo',
    ouGdpr: 'GDPR',
    ouAzureGroupId: 'ID de grupo de Azure AD',
    ouAzureGroupIdHint: 'Vincula esta OU con su grupo real en Azure AD para el árbol jerárquico. Déjalo vacío si aún no está provisionado.',
    ouAzureGroupIdSelectPlaceholder: '— Selecciona un grupo raíz de Azure AD —',
    ouAzureGroupIdLoading: 'Cargando grupos de Azure AD…',
    ouAzureGroupIdRootsError: 'No se pudo cargar la lista de grupos de Azure AD. Puedes escribir el ID manualmente.',
    ouAzureGroupIdCurrentUnknown: 'Grupo vinculado actual (no aparece en la lista)',
    ouAzureGroupIdManualToggle: 'Escribir el ID manualmente',
    ouAzureGroupIdListToggle: 'Elegir de la lista',
    ouActivate: 'Activar OU',
    ouDeactivate: 'Desactivar OU',
    ouActivateCascadeTitle: 'Activar OU y dependientes',
    ouActivateCascadeConfirm: 'Al activar "{{name}}" se activará también toda su descendencia (unidades dependientes afectadas: {{units}}). Podrás desactivarlas de forma individual después.',
    ouDeactivateCascadeTitle: 'Desactivar OU y dependientes',
    ouDeactivateCascadeConfirm: 'Al desactivar "{{name}}" se desactivará también toda su descendencia (unidades dependientes afectadas: {{units}}).',
    ouActiveSaveError: 'No se pudo guardar el cambio de estado de la OU. Intenta de nuevo.',
    ouExpand: 'Expandir',
    ouLockedHint: "Tu unidad organizativa: no puede quitarse del alcance.",
    ouCollapse: 'Colapsar',
    ouSelectPlaceholder: 'Seleccionar OU…',
    ouSearchPlaceholder: 'Buscar OU…',
    ouSearchNoResults: 'Sin resultados.',
    ouInactiveHint: 'OU inactiva: no se puede elegir como alcance nuevo.',
    ouSelectAllInLevel: 'Seleccionar todo',
    ouBackToLevels: 'Volver al nivel anterior',
    ouErrorName: 'El nombre de la OU es obligatorio',
    ouTimezone: 'Zona Horaria',
    ouTimezoneSelect: 'Selecciona zona horaria',
    ouErrorTimezone: 'La zona horaria es obligatoria',
    // Table columns
    colFundamental: 'Fundamental',
    colCondition: 'Condición',
    placeholderAnalytics: 'Dashboard unificado de Analytics — Ver vista Ejecutivo para detalle completo',
    // Analytics KPIs
    activeUsersLabel: 'Colaboradores activos',
    avgCulturalScore: 'Score cultural promedio',
    participationRateLabel: 'Tasa de participación',
    omissionRateLabel: 'Tasa de omisión',
    thisMonth: 'este mes',
    // Rules tab
    rulesTitle: 'Reglas de Negocio',
    restoreDefaults: 'Restaurar Defaults',
    restoreDefaultsTitle: 'Restaurar configuración por defecto',
    restoreDefaultsDesc: 'Se restablecerán todos los valores de las reglas de negocio a su configuración original. Esta acción no se puede deshacer.',
    restoreDefaultsConfirm: 'Sí, restaurar',
    rn001Title: 'Criterios de Reunión',
    rn001Subtitle: 'Define la duración de reuniones que activan encuesta',
    rn002Title: 'Reglas de Exclusión',
    rn002Subtitle: 'Escenarios donde NO se detonan encuestas',
    rn004Title: 'Límites por Usuario',
    rn004Subtitle: 'Controla la cantidad de encuestas que recibe cada persona',
    rn005Title: 'Límite Diario de Encuestas',
    rn005Subtitle: 'Número máximo de encuestas que un usuario puede recibir por día',
    fieldMinSessionDuration: 'Duración mínima de sesión',
    fieldMaxSessionDuration: 'Duración máxima de sesión',
    fieldMinParticipants: 'Mínimo de participantes',
    fieldMaxParticipants: 'Máximo de participantes',
    fieldExclRecurring: 'Excluir reuniones recurrentes',
    fieldExclRecurringSub: 'No aplicar en juntas semanales, dailies, etc.',
    fieldExclWorkHours: 'Excluir fuera de horario laboral',
    fieldExclWorkHoursSub: 'Solo aplicar dentro del horario configurado por OU',
    fieldMaxSurveysWeek: 'Máximo de encuestas por semana',
    fieldMaxParticipantsPerSurvey: 'Máximo de participantes a evaluar por encuesta',
    fieldMinInterval: 'Intervalo mínimo entre encuestas',
    fieldMaxSurveysDay: 'Máximo de encuestas por día por usuario',
    rn005Info: 'Si un usuario ya recibió el máximo de encuestas en el día, las siguientes se posponen al día hábil siguiente respetando el orden de prioridad configurado.',
    suffixMinutes: 'minutos',
    suffixUsers: 'usuarios',
    suffixSurveysWeek: 'encuestas/semana',
    suffixPersons: 'personas',
    suffixHours: 'horas',
    suffixSurveysDay: 'encuestas / día',
    customizableByOU: 'Personalizable por OU',
    cancelChanges: 'Cancelar cambios',
    saveConfig: 'Guardar configuración',
    rulesConfig: 'Configuración',
    rulesStatus: 'Estado',
    rulesCustom: 'Personalizado',
    rulesSave: 'Guardar',
    rulesCancel: 'Cancelar',
    rulesSchedule: 'Horario',
    rulesInheritsGlobal: '↑ Hereda global',
    rulesInherited: 'Heredado',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Personalizar',
    tplCatAll: 'Todos',
    tplCatGeneral: 'General',
    tplCatCustom: 'Personalizada',
    // Users tab
    usersTitle: 'Gestión de Usuarios',
    searchUser: 'Buscar usuario...',
    newUser: 'Nuevo usuario',
    // Notifications tab
    notificationsTitle: 'Configuración de Notificaciones',
    notifOmitirTitle: 'Notificación de "OMITIR"',
    notifyAfter: 'Notificar después de',
    consecutiveOmissions: '"OMITIR" consecutivos',
    notifyTo: 'Notificar a:',
    notifyUser: 'Usuario',
    notifyDirectManager: 'Manager directo',
    notifyAdminOU: 'Administrador OU',
    messageForUser: 'Mensaje para el usuario:',
    availableVarsOmitir: 'Variables disponibles: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Omisiones Europa (BU)',
    manualOnlyGDPR: 'Solo manual — GDPR',
    gdprWarning: 'Por regulaciones legales (GDPR), los correos de omisión para Europa nunca se envían automáticamente. El administrador debe redactarlos, revisarlos y enviarlos manualmente.',
    emailTemplateEmployee: 'Plantilla de correo — empleado Europa:',
    reviewBeforeSending: 'Revisar y personalizar antes de cada envío.',
    generalNotificationsTitle: 'Notificaciones Generales',
    notifMessageLabel: 'Mensaje de la notificación:',
    notifMessagePlaceholder: 'Escribe el mensaje que deseas enviar a los colaboradores...',
    notifAudienceLabel: 'Audiencia:',
    notifAudienceGlobal: 'Global (excl. Europa)',
    sendNotification: 'Enviar notificación',
    availableVarsGeneral: 'Variables disponibles: {nombre}, {ou}, {fecha}',
    saveChanges: 'Guardar cambios',
    saveTemplates: 'Guardar plantillas',
    // Analytics placeholder
    analyticsComingSoon: 'Dashboard de Analytics — en desarrollo. Ver vista Ejecutivo para detalle completo.',
    // Table column: type
    colType: 'Tipo',
    // Templates catalog
    tplCategory: 'Categoría',
    tplQuestions: 'preguntas',
    tplUse: 'Usar',
    tplDeleteTitle: 'Eliminar template',
    tplDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    tipDeleteTitle: 'Eliminar tip',
    tipDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    // Tips form
    tipEditTitle: 'Editar tip',
    tipAddTitle: 'Agregar tip',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Selecciona un fundamental…',
    tipFormDailyHabit: 'Daily Habit vinculado',
    tipFormSelectDailyHabit: 'Selecciona un Daily Habit…',
    tipFormOperator: 'Operador',
    tipFormThreshold: 'Umbral %',
    tipFormMax: 'Máx %',
    tipFormType: 'Tipo de tip',
    tipFormName: 'Nombre del tip',
    tipFormNamePlaceholder: 'Ej. Aprendizaje Sobresaliente',
    tipFormText: 'Texto del tip',
    tipFormTextPlaceholder: 'Mensaje que verá el colaborador…',
    tipFormActivationRule: 'Condición de resultado',
    tipFormActive: 'Activo',
    tipFormPreview: 'Vista previa',
    tipRangeMin: 'Límite mínimo',
    tipRangeMax: 'Límite máximo',
    tipHintCondition: 'Score promedio del fundamental (0–100). Ej: de 0 a 40 activa el tip en resultados bajos.',
    tipHintBehavior: 'Comportamiento específico al que aplica este tip.',
    tipFieldObserved: 'Texto observado',
    tipTagGreen: 'caja verde clara',
    tipTagDark: 'caja oscura',
    tipTagBlue: 'recuadro Siguiente Nivel',
    tipHintObserved: 'Lo que los compañeros observan. Aparece en cursiva en panel de logros.',
    tipFieldGrowthSuggestion: 'Sugerencia Para Crecer',
    tipHintGrowthSuggestion: 'Sugerencia accionable que aparece junto al reconocimiento.',
    tipFieldLevelName: 'Nombre del nivel',
    tipLevelNamePlaceholder: 'Ej. Impulso Necesario, En Construcción…',
    tipCrecerPairedPlaceholder: 'Ej. Menciona al consumidor: En tu próxima decisión, pregunta…',
    tipTranslations: 'Traducciones',
    tipAddLang: '+ Agregar:',
    tipPreviewContext: 'Así se verá en el dashboard del colaborador:',
    tipSave: 'Guardar tip',
    tipSaveError: 'Para guardar, completa los siguientes campos:',
    colContent: 'Contenido',
    colActive: 'Activo',
    // Operators
    opGte: 'mayor o igual',
    opLte: 'menor o igual',
    opGt: 'mayor que',
    opLt: 'menor que',
    opBetween: 'Entre (rango)',
    // Actions form
    actionEditTitle: 'Editar acción',
    actionNewTitle: 'Nueva acción',
    actionFormTitle: 'Título de la acción',
    actionFormTitlePlaceholder: 'Ej. Propón una acción concreta',
    actionFormDescription: 'Descripción completa',
    actionFormDescPlaceholder: 'Descripción de la acción…',
    actionActivationRule: 'Regla de activación',
    actionActivationRuleHint: 'Score promedio del fundamental (1–4). Define el rango que activa esta acción.',
    actionRuleMin: 'Límite mínimo',
    actionRuleMax: 'Límite máximo',
    actionRangeLabel: 'Rango',
    actionNextLevelText: 'Texto "Siguiente Nivel"',
    actionNextLevelHint: 'Aparece en el recuadro azul de la tarjeta.',
    actionNextLevelPlaceholder: 'Ej. Para llegar al siguiente nivel, enfócate en…',
    actionPreview: 'Vista previa',
    actionPreviewEmpty: 'Completa el formulario para ver la vista previa',
    actionTranslations: 'Traducciones',
    actionTransComplete: 'Traducción completa',
    actionTransMissing: 'Traducción incompleta',
    actionPreviewContext: 'Así se verá en el dashboard del colaborador:',
    actionFormDescHint: 'Se muestra al abrir la acción.',
    actionSave: 'Guardar acción',
    actionSaveError: 'Para guardar, completa los siguientes campos:',
    actionDeleteTitle: 'Eliminar acción',
    actionDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    // Fundamental form
    fundEditTitle: 'Editar Fundamental',
    fundNewTitle: 'Nuevo Fundamental',
    fundFormFullName: 'Nombre completo',
    fundFormFullNamePlaceholder: 'Ej. Mindset & Behavior - Learner',
    fundFormShortName: 'Nombre corto',
    fundFormShortNamePlaceholder: 'Ej. Learner',
    fundFormDescription: 'Descripción',
    fundFormDescriptionPlaceholder: 'Breve descripción de este fundamental...',
    fundFormIcon: 'Ícono',
    fundFormColor: 'Color',
    fundFormUrl: 'URL de referencia',
    fundFormMicrositeUrl: 'URL de micrositio',
    fundFormUrlPlaceholder: 'https://...',
    imageUploadSelect: 'Subir imagen',
    imageUploadChange: 'Cambiar imagen',
    imageUploadInvalidFormat: 'Formato no soportado. Usa PNG, JPG, WEBP o SVG.',
    imageUploadTooLarge: 'El archivo excede el tamaño máximo permitido (2 MB).',
    catalogSaveError: 'No se pudieron guardar los cambios del catálogo. Intenta de nuevo.',
    catalogImageUploadError: 'No se pudo subir la imagen. Intenta de nuevo.',
    fundFormLanguage: 'Idioma',
    fundFormAllLangsRequired: 'Completa el nombre completo, nombre corto y descripción en los 7 idiomas para poder guardar.',
    // Core Behavior form
    behEditTitle: 'Editar Daily Habit',
    behNewTitle: 'Nuevo Daily Habit',
    behFormName: 'Nombre del Daily Habit',
    behFormNamePlaceholder: 'Ej. Humility & Openness',
    behFormAllLangsRequired: 'Completa el nombre en los 7 idiomas para poder guardar.',
    behFormFundamental: 'Fundamental vinculado',
    behFormIntro: 'Intro / contexto de evaluación',
    behFormIntroPlaceholder: 'Ej. En esta junta, esta persona…',
    behFormRoles: 'Roles aplicables',
    behFormRolesHint: '¿a quién aplica este Daily Habit?',
    fundDeleteTitle: 'Eliminar fundamental',
    fundDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    behDeleteTitle: 'Eliminar Daily Habit',
    behDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    fundFormImage: 'Imagen',
    attNewTitle: 'Nueva Actitud y Comportamiento',
    attEditTitle: 'Editar Actitud y Comportamiento',
    attFormName: 'Nombre de la Actitud y Comportamiento',
    attFormNamePlaceholder: 'Ej. Colaboración activa',
    attFormDescription: 'Descripción de la Actitud y Comportamiento',
    attFormDescriptionPlaceholder: 'Breve descripción de esta actitud y comportamiento...',
    attFormAllLangsRequired: 'Completa el nombre en los 7 idiomas para guardar.',
    attFormImage: 'Imagen',
    attDeleteTitle: 'Eliminar Actitud y Comportamiento',
    attDeleteDesc: '¿Eliminar "{{name}}"? Sus Daily Habits también se desactivarán.',
    catalogAttitudesLabel: 'actitudes y comportamientos',
    catalogSelectAttitude: 'Selecciona una Actitud y Comportamiento de la lista',
    catalogBackToFundamentals: 'Volver a Fundamentales',
    catalogBackToAttitudes: 'Volver a Actitudes y Comportamientos',
    catalogGroupWithAttitudes: 'Agrupar en Actitudes y Comportamientos',
    // Catalog
    catalogNoFundamentals: 'Sin fundamentales',
    // Madurez Cultural editor
    madurezEditTitle: 'Editar niveles de Madurez Cultural',
    madurezFrameworkTitle: 'Madurez Cultural — Marco de niveles',
    nivelesAdopcionTitle: 'Etapas de adopción de un Daily Habit — Marco de niveles',
    nivelesAdopcionEditTitle: 'Editar etapas de adopción de un Daily Habit',
    madurezLabelPlaceholder: 'Etiqueta',
    // Notifications audiences
    audienceGlobal: 'Global (excl. Europa)',
    audienceMexico: 'México',
    audienceLATAM: 'LATAM',
    audienceUSA: 'USA',
    audienceFOSE: 'FOSE',
    // Rules tab — new keys
    rn000Title: 'Desactivar App por OU',
    rn000Subtitle: 'Apaga completamente Sigma Pulse para una o más unidades organizacionales. Los colaboradores de esas OUs no recibirán encuestas ni notificaciones.',
    rn000Warning: 'Al desactivar una OU, todos sus colaboradores dejan de recibir encuestas inmediatamente. Los datos históricos se conservan.',
    rn003Title: 'Horario Laboral por OU',
    rn003Subtitle: 'Horario en que se aplican encuestas (hora local)',
    rn003GlobalDefault: 'Horario global por defecto',
    rn003GlobalNote: 'Aplica a todas las OUs que no tengan un horario personalizado.',
    rn003TimeConnector: 'a',
    ouActive: 'Activa',
    ouDisabled: 'Desactivada',
    rn002KwLabel: 'Excluir solo si el nombre contiene:',
    rn002KwHint: '(vacío = todas las recurrentes)',
    rn002KwPlaceholder: 'Agregar palabra clave...',
    // Users tab — new keys
    usersAdminTitle: 'Gestión de Administradores',
    addAdmin: 'Agregar Administrador',
    editAdmin: 'Editar Administrador',
    newAdmin: 'Nuevo Administrador',
    adminEmail: 'Correo electrónico',
    adminUser: 'Usuario',
    userSearchPlaceholder: 'Busca por nombre o correo…',
    userSearchNoResults: 'No se encontraron usuarios',
    userSearchError: 'Error al buscar usuarios',
    adminRole: 'Rol',
    adminRolePlaceholder: 'Selecciona un rol...',
    adminOU: 'Unidad Operativa (OU)',
    adminOUPlaceholder: 'Selecciona una OU...',
    adminOUAll: 'Todas (Acceso a todas las OUs)',
    adminBU: 'Unidad de Negocio (BU) — opcional',
    adminBUPlaceholder: 'Toda la OU (sin restricción)',
    adminBUHint: 'Si no seleccionas BU, el admin gestiona toda la OU.',
    colUser: 'Usuario',
    colAlcance: 'Alcance',
    colPermisos: 'Permisos',
    colEstado: 'Estado',
    permGlobalTitle: 'Admins OU/BU pueden crear encuestas',
    permGlobalDesc: 'Cuando está activo, todos los Admins OU/BU pueden crear y enviar encuestas (sujeto a aprobación del Admin General o del Admin Pulso).',
    permEnabled: 'Activado',
    permDisabled: 'Desactivado',
    permCreateSurveys: 'Crear encuestas',
    permViewAnalytics: 'Ver Analytics',
    permManageUsers: 'Gestionar Usuarios',
    permApproveSurveys: 'Aprobar encuestas',
    permCatalogFund: 'Catálogo Fundamentales',
    permCatalogOus: 'Catálogo OUs',
    // 2026-08-08 — reacomodo del menú de Administración
    administratorsTab: 'Gestión de Administradores',
    catalogFundTab: 'Catálogo Fundamentales',
    catalogOusTab: 'Catálogo OUs',
    rolesPulsoTab: 'Configurar roles y permisos',
    rolesPulsoTitle: 'Configurar roles y permisos',
    rolesPulsoAllScopes: 'Todas',
    rolesPulsoAlreadyNote: 'Esta persona ya es administrador de Pulso — edita sus datos abajo.',
    rolesPulsoCannotEditGlobal: 'Esta persona ya tiene el rol de Admin General. Ese rol no se gestiona desde aquí.',
    administratorsTitle: 'Gestión de Administradores',
    administratorsDesc: 'Alta y baja de administradores globales del sistema.',
    addGlobalAdmin: 'Agregar administrador',
    newGlobalAdmin: 'Nuevo administrador global',
    adminGlobalRemoveTitle: 'Quitar administrador global',
    adminGlobalRemoveDesc: '¿Quitar a "{{name}}" como administrador global? Conservará su cuenta como colaborador estándar.',
    userDeleteTitle: 'Quitar administrador',
    userDeleteDesc: '¿Quitar a "{{name}}" como administrador? Conservará su cuenta como colaborador estándar, sin permisos de administración.',
    userCreated: 'Usuario creado correctamente.',
    userSaveError: 'No se pudieron guardar los cambios. Intenta de nuevo.',
    userSaveForbidden: 'No tienes permiso para modificar a este administrador. Solo un Admin General puede hacerlo.',
    userCreateErrorNotInAd: 'No se pudo crear el usuario: el correo no existe en Azure AD.',
    userDeleteError: 'No se pudo quitar el rol de administrador. Intenta de nuevo.',
    noUsersFound: 'Sin resultados',
    adminCount: 'administradores',
    filterEmailPlaceholder: 'Buscar por correo electrónico...',
    filterRoleLabel: 'Filtrar por rol',
    filterRoleAll: 'Todos los roles',
    filterClear: 'Limpiar filtros',
    rolesMultiHint: 'Puedes seleccionar más de un rol manteniendo presionada la tecla Ctrl (Cmd en Mac).',
    modulesTitle: 'Módulos',
    modulesHint: 'Controla el acceso a los módulos del producto, sin importar el rol asignado.',
    modulePulso: 'Pulso',
    moduleBrillamos: 'Reconocimiento',
    permAllGranted: 'Todos concedidos',
    userNotManageable: 'No puedes gestionar a este usuario',
    // Notifications tab — new keys
    messageForManager: 'Mensaje para el manager:',
    emailTemplateManager: 'Plantilla de correo — manager Europa:',
    notifOUPersonalization: 'Personalización por OU',
    addOUPersonalization: 'Agregar personalización',
    europaNoAutoSend: 'Estos correos no se envían automáticamente. Deben enviarse manualmente y estar alineados con el responsable de privacidad de Europa.',
    europaActivateTitle: '¿Activar notificaciones Europa?',
    europaActivateDesc: 'Las notificaciones de omisiones para Europa están sujetas a regulaciones GDPR estrictas. Al activar esta sección confirmas que cuentas con autorización del responsable de privacidad de la OU Europa y que los correos serán enviados manualmente con revisión previa.',
    europaActivateConfirm: 'Sí, activar con responsabilidad',
    includeEuropa: 'Incluir Europa (BU)',
    includeEuropaHint: 'requiere revisión GDPR antes de enviar',
    europaSectionDisabled: 'Sección desactivada — activa el switch para configurar',
    ouPersonalizedSingular: 'OU personalizada',
    ouPersonalizedPlural: 'OUs personalizadas',
    notifCustomUserMsgPlaceholder: 'Mensaje personalizado para el usuario…',
    notifCustomMgrMsgPlaceholder: 'Mensaje personalizado para el manager…',
    kwRemove: 'Quitar',
    kwAdd: 'Agregar',
    // Legacy keys kept for compatibility
    permissions: 'Permisos',
    rules: 'Reglas de negocio',
    catalog: 'Catálogo',
    createUser: 'Crear usuario',
    editUser: 'Editar usuario',
    deleteUser: 'Eliminar usuario',
    roles: 'Rol',
    organizationalUnit: 'Unidad Organizacional',
    minDuration: 'Duración mínima (min)',
    maxDuration: 'Duración máxima (min)',
    minParticipants: 'Participantes mínimos',
    maxPerDay: 'Máx. evaluaciones por día',
    maxPerWeek: 'Máx. evaluaciones por semana',
    omissionThreshold: 'Umbral de omisiones',
    columns: 'Columnas',
    colPickerTitle: 'Columnas visibles',
    colPickerReset: 'Restablecer',
    pagerRowsPerPage: 'Filas por página',
    pagerOf: 'de',
    confirmMoveToTrash: '¿Mover a papelera?',
    confirmMoveToTrashMsg: 'La encuesta se moverá a la papelera y se eliminará definitivamente en 30 días. Puedes restaurarla antes de ese plazo.',
    confirmMoveBtn: 'Mover a papelera',
    confirmDeleteForeverTitle: '¿Eliminar definitivamente?',
    confirmDeleteForeverMsg: 'Esta acción es irreversible. La encuesta y todos sus datos se borrarán para siempre.',
    confirmDeleteForeverBtn: 'Eliminar para siempre',
    trashTitle: 'Papelera de encuestas',
    trashSubtitle: 'Las encuestas se eliminan definitivamente después de 30 días',
    trashEmpty: 'La papelera está vacía',
    trashRestore: 'Restaurar',
    trashDaysLeft: 'días restantes',
    colSurvey: 'Encuesta',
    trashResponses: 'resp.',
    trashTimeLeft: 'Tiempo restante',
    trashDeletedBy: 'Eliminado por',
    trashDeletedAt: 'Fecha eliminación',
    trashDays: 'días',
    trashExpiresTODAY: 'Vence hoy',
    filterAll: 'Todos',
    filterSearchName: 'Buscar nombre…',
    filterSearchCreator: 'Buscar creador…',
    filterFrom: 'Desde',
    filterTo: 'Hasta',
    filterClearDates: 'Limpiar fechas',
    pauseSurvey: 'Pausar',
    activateSurvey: 'Activar',
    builderNewTitle: 'Nueva Encuesta',
    builderEditTitle: 'Editar Encuesta',
    builderNewTemplateTitle: 'Nuevo Template',
    builderEditTemplateTitle: 'Editar Template',
    builderBackToSurveys: 'Volver a encuestas',
    builderSaveDraft: 'Guardar borrador',
    builderPublish: 'Publicar encuesta',
    builderStep1: 'Información Básica',
    builderStep2: 'Audiencia y Frecuencia',
    builderStep3: 'Preguntas',
    builderStep4: 'Revisión',
    builderPreview: 'Vista Previa',
    builderName: 'Nombre de la encuesta',
    builderNamePlaceholder: 'Ej: Evaluación Post-Reunión Q2',
    builderDescription: 'Descripción',
    builderDescriptionPlaceholder: 'Describe el propósito de esta encuesta…',
    builderApproach: 'Enfoque',
    builderApproachIndividual: 'Individual',
    builderApproachCollective: 'Colectivo',
    builderAnonymous: 'Evaluación anónima',
    builderAnonymousSub: 'Los evaluados no sabrán quién los evaluó',
    dayMon: 'Lunes', dayTue: 'Martes', dayWed: 'Miércoles', dayThu: 'Jueves',
    dayFri: 'Viernes', daySat: 'Sábado', daySun: 'Domingo',
    dayMonShort: 'Lun', dayTueShort: 'Mar', dayWedShort: 'Mié', dayThuShort: 'Jue',
    dayFriShort: 'Vie', daySatShort: 'Sáb', daySunShort: 'Dom',
    dayLetterMon: 'L', dayLetterTue: 'M', dayLetterWed: 'X', dayLetterThu: 'J',
    dayLetterFri: 'V', dayLetterSat: 'S', dayLetterSun: 'D',
    activeDaysAll: 'La encuesta estará activa toda la semana',
    activeDaysPrefix: 'La encuesta estará activa de:',
    activeDaysNone: 'Ningún día seleccionado',
    workdays: 'Días laborales',
    builderExitTitle: '¿Salir del editor?',
    builderExitDesc: 'Los cambios no guardados se perderán si sales ahora.',
    builderExitCancel: 'Seguir editando',
    builderExitConfirm: 'Sí, salir',
    builderValidationTitle: 'Campos obligatorios',
    builderValidationDesc: 'Por favor completa los siguientes campos antes de continuar:',
    builderValidationClose: 'Entendido',
    builderValidationName: 'Identificador Interno',
    builderValidationSurveyType: 'Tipo de encuesta',
    builderValidationStartDate: 'Fecha de inicio',
    builderValidationEndDate: 'Fecha de fin',
    builderValidationDateRange: 'La fecha de fin no puede ser menor a la fecha de inicio',
    builderValidationActiveDays: 'Al menos un día de activación',
    builderValidationStartDatePast: 'La fecha de inicio ya pasó; la encuesta nunca se publicaría',
    builderValidationEndDatePast: 'La fecha de fin ya pasó; la encuesta nunca se publicaría',
    builderValidationMeetingId: 'Captura el ID del Meeting',
    builderValidationPeople: 'Selecciona al menos una persona',
    builderValidationOU: 'Selecciona al menos una OU',
    builderValidationNoQuestions: 'Debes agregar al menos una pregunta para poder continuar. No se pueden generar encuestas sin preguntas.',
    builderValidationMinParticipants: 'El mínimo de participantes debe ser al menos 1',
    builderValidationMaxParticipants: 'El máximo de participantes debe ser al menos 1',
    builderValidationParticipantsRange: 'El mínimo de participantes no puede ser mayor al máximo',
    builderValidationTranslations: 'Traducciones incompletas',
    // Builder new keys
    builderCloseEditor: 'Cerrar editor',
    builderPrevious: 'Anterior',
    builderNext: 'Siguiente',
    builderSaveTemplate: 'Guardar como template',
    builderInternalId: 'Identificador interno',
    builderInternalIdHint: 'Solo visible para administradores — los empleados no ven este nombre al responder',
    builderSurveyTypeStar: 'Tipo de encuesta',
    builderTypeGeneral: 'General',
    builderTypeGeneralDesc: 'Se rige por reglas de negocio. Se dispara automáticamente tras reuniones.',
    builderTypePersonalized: 'Personalizada',
    builderTypePersonalizedDesc: 'Vinculada a una sesión específica de Teams por Meeting ID.',
    builderPeriod: 'Período de la encuesta',
    builderStartLabel: 'Inicio',
    builderEndLabel: 'Fin',
    builderPeriodHint: 'La encuesta se activará en la fecha de inicio y se desactivará automáticamente al finalizar',
    builderActiveDaysLabel: 'Días de activación',
    builderActiveDaysLockedHint: 'El día queda fijado automáticamente porque el rango de fechas es de un solo día',
    builderCustomTag: 'Personalizado',
    builderAudienceSectionTitle: 'Audiencia',
    builderWhoApplies: '¿A quién aplica esta encuesta?',
    builderSelectOneOrMoreOUs: 'Selecciona una o varias OUs',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Todas las OUs y BUs',
    builderExcludesEurope: 'excluye Europa',
    builderGlobalAdminOUAccess: 'Administrador Global — tienes acceso a todas las OUs del sistema.',
    builderLegalRegulation: 'Regulación legal — siempre campo separado',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'GDPR — Regulación legal',
    builderEuropeExcludedNote: 'Europa nunca está incluida en campañas Globales ni multi-OU por cumplimiento legal.',
    builderEuropaAuthNote: 'Recuerda contar con autorización de la OU Europa antes de enviar encuestas a esta región.',
    builderOUNotLinkedToAzureAD: 'Esta OU todavía no tiene subniveles disponibles — vincúlala con su grupo de Azure AD desde Administración › Unidades Organizacionales.',
    builderAudienceCustomTitle: 'Destinatarios',
    builderAudienceCustomSubtitle: 'Define quiénes recibirán esta encuesta personalizada.',
    builderRecipientsLabel: 'Destinatarios',
    builderByMeetingId: 'Por Meeting ID',
    builderByPeople: 'Personas específicas',
    builderByOU: 'Por organigrama (OU)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'Personas',
    audienceTypeOU: 'OU',
    builderMeetingIdHint: 'Se aplicará a todos los participantes de esa sesión de Teams',
    builderSelectPeople: 'Selecciona personas de la lista',
    builderAllOUs: 'Todas las OUs',
    builderAllAvailableAdded: 'Todos los disponibles ya fueron agregados',
    builderSearchPeoplePlaceholder: 'Buscar persona por nombre…',
    builderLoadingPeople: 'Cargando personas…',
    builderErrorLoadingPeople: 'No se pudo cargar la lista de personas. Intenta de nuevo.',
    builderPersonSelected: 'persona seleccionada',
    builderPeopleSelected: 'personas seleccionadas',
    builderSelectOU: 'Selecciona una OU...',
    builderSelectOUForTeam: 'Selecciona una OU para ver sus colaboradores',
    builderQuestionsTitle: 'Preguntas',
    builderEuropaQuestionsNote: 'Modo Europa: encuesta libre, sin vinculación a Fundamentales. Solo preguntas sobre la junta (reunión).',
    builderQuestionsApplyToAll: 'Cada pregunta se aplica a cada participante de la reunión.',
    builderFilterAll: 'Todos',
    builderNoQuestions: 'Aún no hay preguntas',
    builderNoQuestionsHint: 'Haz clic en "+ Agregar pregunta" para empezar',
    builderNoQuestionsOfType: 'Sin preguntas de este enfoque',
    builderAddQuestion: '+ Agregar pregunta',
    builderQuestionLabel: 'Pregunta',
    builderDeleteQuestion: 'Eliminar',
    builderApproachLabel: 'Enfoque',
    builderIndividualSub: 'Evalúa a cada participante',
    builderCollectiveSub: 'Para la sesión en general',
    builderPresentationMode: 'Modo de presentación',
    builderMatrix: 'Matriz General',
    builderMatrixSub: 'Pregunta sobre la junta o tema general',
    builderIndividualCard: 'Individual',
    builderIndividualCardSub: 'Una tarjeta por persona',
    builderTypeLabel: 'Tipo',
    builderFundamentalLabel: 'Fundamental',
    builderSelectFundamental: 'Selecciona un Fundamental...',
    builderDailyHabitLabel: 'Daily Habit',
    builderSelectDailyHabit: 'Selecciona un Daily Habit...',
    builderQuestionText: 'Texto de la pregunta',
    builderQuestionTextPlaceholder: 'Escribe la pregunta aquí',
    builderIconLabel: 'Ícono',
    builderOptional: '(opcional)',
    builderChangeIcon: 'Cambiar',
    builderSelectIconBtn: 'Seleccionar ícono',
    builderOptionsLabel: 'Opciones (máx. 4 + "No Observable")',
    builderNoObservable: 'No Observable',
    builderRemoveNoObs: 'Quitar No Observable',
    builderAddNoObs: 'Agregar "No Observable"',
    builderAddOption: 'Agregar Opción',
    builderMaxOptions: 'Máximo de 4 opciones alcanzado',
    builderNPSInfo: 'NPS: escala del 0 al 10. Pregunta libre, sin asignar a participantes.',
    builderOpenInfo: 'Espacio libre para que el evaluador escriba su respuesta.',
    builderCampaignWeight: 'Peso de campaña',
    builderAdminGlobalOnly: 'Solo Admin General',
    builderCampaignWeightSub: 'Mayor peso = mayor prioridad cuando hay varias encuestas activas. Solo el Admin General puede modificarlo.',
    builderWeightBase: 'Peso base (1–10)',
    builderWeightVeryLow: 'Muy Baja',
    builderWeightLow: 'Baja',
    builderWeightMedium: 'Media',
    builderWeightHigh: 'Alta',
    builderWeightVeryHigh: 'Muy Alta',
    builderBoostUrgent: 'Boost urgente',
    builderBoostUrgentSub: 'Eleva esta encuesta sobre todas las demás temporalmente',
    builderBoostDays: 'días',
    builderBoostActiveDays: 'día',
    builderBoostActiveMsg: 'Boost activo — esta encuesta tendrá máxima prioridad durante',
    builderNoBoostMsg: 'Sin boost activo — prioridad según peso base',
    builderParticipantsTitle: 'Participantes a evaluar',
    builderParticipantsSub: 'Define cuántas personas se evalúan por encuesta. Mínimo para anonimato y máximo para no saturar.',
    builderMinParticipantsLabel: 'Mínimo de participantes',
    builderMinParticipantsHint: 'Mín. para garantizar anonimato',
    builderMaxParticipantsLabel: 'Máximo de participantes',
    builderMaxParticipantsHint: 'Máx. personas a evaluar por encuesta',
    builderPrivacyTitle: 'Privacidad y anonimato',
    builderPrivacySub: 'Define si las retroalimentaciones se asociarán a la identidad del respondente.',
    builderEnableAnonymity: 'Activar anonimato',
    builderAnonymityDesc: 'Las retroalimentaciones no llevarán nombre de usuario — solo respuesta y hora',
    builderTranslationsTitle: 'Traducciones',
    builderTranslationsEuropeSub: 'Audiencia Europa — se requieren los 6 idiomas. Usa el toggle para activar o desactivar un idioma.',
    builderTranslationsSub: 'Se requiere traducción al Inglés como mínimo. Usa el toggle para activar idiomas adicionales.',
    builderAutoTranslateNote: 'Las traducciones se generan automáticamente con Azure Translator. Revisa y ajusta cada campo según sea necesario.',
    builderLangNotApplicable: 'No aplica',
    builderLangComplete: 'Listo',
    builderLangPending: 'Pendiente',
    builderLangRequired: 'Requerido',
    builderLangOptional: 'Opcional',
    builderAutoTranslateBtn: 'Traducir auto.',
    builderAutoTranslating: 'Traduciendo…',
    builderAutoTranslateError: 'No se pudo completar la traducción automática. Intenta de nuevo.',
    sessionExpiredError: 'Tu sesión expiró. Recarga la página e inicia sesión de nuevo.',
    builderSourceLangLabel: 'Idioma origen',
    builderSourceLangHint: 'Idioma en el que estás redactando esta pregunta. Los demás idiomas se pedirán como traducción en la sección Traducciones.',
    builderLangApplies: 'Aplica',
    builderLangDoesNotApply: 'No aplica',
    builderTrlName: 'Nombre:',
    builderTrlDesc: 'Descripción:',
    builderTrlEmpty: 'vacío',
    builderLangDisabled: 'Esta lengua está desactivada para esta encuesta.',
    builderReviewTitle: 'Revisar y publicar',
    builderReviewTemplateTitle: 'Revisar template',
    builderEuropaPublishNote: 'Modo Europa: campaña independiente por GDPR. Recuerda contar con autorización de la OU Europa.',
    builderPublishIdLabel: 'Identificador',
    builderPublishInternal: '(interno)',
    builderPublishTypeLabel: 'Tipo',
    builderPublishAudienceLabel: 'Audiencia',
    builderPublishQuestionsLabel: 'Preguntas',
    builderPublishActiveDaysLabel: 'Días activos',
    builderPublishExpirationLabel: 'Expiración',
    builderPublishAnonymityLabel: 'Anonimato',
    builderPublishAnonymousVal: 'Anónima',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Completa antes de publicar:',
    builderCompleteBeforeSave: 'Completa antes de guardar:',
    builderReadyToPublish: 'Todo listo. Haz clic en Publicar Encuesta para activarla.',
    builderReadyToSaveTemplate: 'Todo listo. Haz clic en Guardar Template para guardarlo.',
    builderIconCatalogTitle: 'Catálogo de íconos',
    builderSystemIcons: 'Iconos del sistema',
    builderNoIcon: 'Sin ícono',
    builderMyCatalog: 'Mi catálogo',
    builderDeleteFromCatalog: 'Eliminar del catálogo',
    builderCatalogEmpty: 'Tu catálogo está vacío — sube un ícono y guárdalo aquí',
    builderUploadIcon: 'Subir nuevo ícono',
    builderIconNamePlaceholder: 'Nombre del ícono (ej. Innovación)',
    builderSelectFile: 'Seleccionar archivo',
    builderInvalidFormat: 'Formato no válido. Usa SVG o PNG con fondo transparente.',
    builderFileTooLarge: 'Archivo muy grande. Máximo 200 KB.',
    builderCustomIcon: 'Ícono personalizado',
    builderSaveForReuse: 'Guardar en catálogo para reutilizar',
    builderUseIcon: 'Usar ícono',
    builderIconHelp: 'SVG o PNG, fondo transparente, 512×512 px recomendado, máx. 200 KB',
    builderPreviewCompleteStep1: 'Completa los datos del Paso 1 para ver la vista previa',
    builderPreviewClickToEdit: 'Haz clic en cualquier texto para editar',
    builderPreviewNoQuestions: 'Las preguntas aparecerán aquí en el Paso 3',
    builderPreviewGeneral: 'General',
    builderPreviewPersonalized: 'Personalizada',
    builderPreviewPulsoEspecifica: 'Pulso Específica',
    builderPreviewChangeIcon: 'Cambiar ícono',
    builderPreviewIndividual: 'Individual',
    builderPreviewCollective: 'Colectivo',
    builderPreviewModeIndividual: 'Individual',
    builderPreviewModeMatrix: 'Matriz General',
    builderPreviewMissingTranslation: '(sin traducción)',
    builderPreviewWriteAnswer: 'Escribe tu respuesta aquí...',
    builderPreviewNoObs: 'No Observable',
    builderPreviewNA: 'N/A',
    // Step nav labels
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Audiencia',
    builderNavPreguntas: 'Preguntas',
    builderNavConfig: 'Configuración',
    builderNavPublicar: 'Publicar',
    builderNavGuardar: 'Guardar',
    // Step 1 title
    builderInfoTitle: 'Información básica',
    // Audience step
    builderSelectAll: 'Seleccionar todo',
    // Language names
    langEn: 'Inglés',
    langDe: 'Alemán',
    langPt: 'Portugués',
    langFr: 'Francés',
    langNl: 'Holandés',
    langRo: 'Rumano',
    // Translation placeholders
    builderTrlPlaceholderIn: 'en',
    builderTrlPlaceholderOpt: 'Opción',
    builderTrlNoText: 'Sin texto aún',
    // New keys added during refactor
    builderLinkedTo: 'Vinculado a',
    builderSelectedIcon: 'Seleccionado',
    builderHidePreview: 'Ocultar vista previa',
    builderShowPreview: 'Mostrar vista previa',
    builderPreviewMorePersons: 'personas más',
    builderPreviewOption1: 'Opción 1',
    builderPreviewOption2: 'Opción 2',
    builderPreviewViewIn: 'Ver en:',
    builderFromOU: 'de',
    builderWillReceiveSurvey: 'recibirán esta encuesta',
    builderPersonsCount: 'personas',
    builderPersonsPlural: 'personas',
    builderPersonSingular: 'persona',
    builderInternalIdPlaceholder: 'Ej: Fundamentales Q1 2026',
    builderMeetingIdPlaceholder: 'Ej: 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Opción',
    builderRemovePerson: 'Quitar',
    builderSaveTemplateMock: 'Guardado como template ✓',
    builderPublishGlobalLabel: 'Global (excl. Europa)',
    builderTypeRating: 'Evaluación (1-4)',
    builderTypeMultiple: 'Opción Múltiple',
    builderTypeOpen: 'Pregunta Abierta',
    builderTypeBehaviors: 'Comportamientos',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'Sistema',
    // Monitor tab
    monitorTab: 'Monitoreo',
    // Trace tab
    traceTab: 'Trazabilidad',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'Sincronización del padrón',
    subtitle: 'De dónde salen los usuarios y las unidades organizacionales, el catálogo de dominios corporativos, y el estado de cada corrida.',
    ouCatalogSync: 'Sincronización de OUs',
    userCatalogSync: 'Sincronización de Usuarios',
    statusNeverRun: 'Nunca ejecutado',
    statusRunning: 'Corriendo…',
    statusSuccess: 'Éxito',
    statusSkipped: 'Saltado',
    statusFailed: 'Error',
    lastRun: 'Última corrida',
    duration: 'Duración',
    triggerScheduled: 'Automático',
    triggerManual: 'Manual',
    created: 'Creados',
    updated: 'Actualizados',
    unchanged: 'Sin cambios',
    skipReason: 'Motivo',
    errorMessage: 'Error',
    nextScheduled: 'Próxima ejecución automática',
    nextScheduledUnknown: 'Se calculará tras la primera corrida',
    padronTitle: 'Padrón',
    padronTotal: 'Fichas en total',
    padronUnclaimed: 'Sin reclamar',
    padronLoading: 'Contando…',
    padronError: 'No se pudo leer el padrón.',
    padronHint: 'Una ficha sin reclamar es una persona del padrón que todavía no ha entrado a la plataforma. No aparece en los listados de administración.',
    identity: "Identidad de contadores",
    identityOk: "Cuadra",
    identityBad: "NO cuadra: {{suma}} vs {{recibidas}}",
    drift: "Desviación de conteo",
    duplicateEmail: "Correos duplicados en el origen",
    ouSubidaARaiz: "Fichas subidas a su unidad raíz",
    ouHuerfanaResuelta: "Unidades inexistentes resueltas por región",
    ouHuerfanaSinResolver: "Unidades rotas SIN resolver",
    managerLinks: "Jefes resueltos",
    runNow: 'Ejecutar ahora',
    runningDisabled: 'Ya está corriendo',
    viewHistory: 'Ver historial',
    hideHistory: 'Ocultar historial',
    historyEmpty: 'Todavía no hay corridas registradas.',
    historyLoading: 'Cargando historial…',
    historyError: 'No se pudo cargar el historial.',
    colDate: 'Fecha',
    colTrigger: 'Disparo',
    colStatus: 'Estado',
    colDuration: 'Duración',
    colDetail: 'Detalle',
    triggerError: 'No se pudo ejecutar el job.',
    triggerConflict: 'El job ya está corriendo — espera a que termine.',
    tabs: {
      users: 'Usuarios',
      ous: 'Unidades organizacionales',
      domains: 'Dominios (Excel)',
      sentinels: 'Correos ignorados (SF)',
    },
    runsTitle: 'Corridas',
    noJobs: 'No hay corridas registradas para esta sección.',
    sfUserSync: 'Usuarios (SuccessFactors)',
    sfOuSync: 'Unidades organizacionales (SuccessFactors)',
    adDomainSweep: 'Barrido de dominios del directorio',
    cuentasBarridas: 'Cuentas habilitadas barridas',
    dominiosObservados: 'Dominios observados',
    dominiosNoDeclarados: 'Observados sin declarar',
    dominiosDesaparecidos: 'Declarados que ya no se observan',
    dominiosDesactivados: 'Dominios desactivados',
    sync: {
      title: 'Fuente de datos',
      desc: 'De dónde sale el padrón de colaboradores.',
      users: 'Origen de los usuarios',
      adOnly: 'Sólo Active Directory',
      adOnlyHint: 'Los corporativos vienen del AD. SuccessFactors sigue corriendo, pero sólo para los colaboradores sin correo corporativo: no están en el AD y de otro modo no entrarían nunca.',
      apiOnly: 'Sólo SuccessFactors',
      apiOnlyHint: 'Todo el padrón viene de SuccessFactors, corporativos incluidos. La corrida del AD queda omitida.',
      adThenApi: 'AD y después SuccessFactors',
      adThenApiHint: 'Corren las dos. SuccessFactors sólo rellena lo que el AD dejó vacío; la única excepción es el país, que siempre lo escribe SuccessFactors.',
      ous: 'Unidades organizacionales',
      ousDesc: 'De dónde sale el árbol de unidades organizacionales.',
      ouSource: 'Origen del árbol',
      ouAd: 'Active Directory',
      ouApi: 'SuccessFactors',
      sf: 'SuccessFactors',
      sfEnabled: 'Sincronización habilitada',
      dryRun: 'Modo simulación',
      dryRunHint: 'La corrida cuenta todo y reporta los resultados, pero NO escribe ningún cambio. Es el modo recomendado para la primera ejecución.',
      sfOn: 'Habilitada',
      sfOff: 'Apagada',
      sfDryRun: 'Habilitada, en simulación',
      sfManagedInUsers: 'Se configura en la pestaña de Usuarios: los mismos interruptores gobiernan las dos corridas.',
      domains: 'Dominios corporativos permitidos — carga por Excel',
      domainsDesc: 'Aplica ÚNICAMENTE a la carga masiva por Excel de Europa y EE. UU. Si añades un dominio, la gente del fichero con ese correo pasa a entrar por SSO y deja de poder registrarse. Si quitas uno, su correo se ignora al cargar y esas personas tendrán que declarar el suyo al registrarse. No afecta a la sincronización con Active Directory ni con SuccessFactors.',
      domainsHint: 'Uno por línea, o separados por comas.',
      domainsCount: '{{n}} dominios',
      domainBadFormat: 'no parece un dominio (revisa espacios, arrobas o rutas)',
      domainDuplicate: 'repetido: se guardará una sola vez',
      domainsRemoved: 'Se van a QUITAR',
      domainsRemovedWarning: 'Su gente dejará de entrar por SSO y podrá registrarse con contraseña.',
      domainsAdded: 'Se van a AÑADIR',
      domainsAddedWarning: 'Su gente quedará obligada a entrar por SSO y no podrá registrarse.',
      domainsReview: 'Revisar y guardar',
      domainsConfirm: 'Confirmar el cambio',
      domainsCancel: 'Cancelar',
      domainsAllInvalid: 'Ningún dominio válido: no se puede guardar la lista vacía.',
      domainsSaved: 'Catálogo de dominios guardado.',
      saved: 'Configuración guardada.',
      loadError: 'No se pudo leer la configuración de fuentes.',
      updatedBy: 'Último cambio por',
      errSession: 'La sesión caducó. Vuelve a entrar y repite el cambio.',
      errForbidden: 'No tienes permiso para guardar esta configuración: hace falta el rol AdminGlobal.',
      errValidation: 'La configuración no pasó la validación: {{detalle}}',
      errValidationPlain: 'La configuración no pasó la validación del servidor.',
      errOther: 'No se pudo guardar (error {{status}}). Si se repite, hay que mirar el log del servicio.',
      errNetwork: 'No se pudo guardar: no hubo respuesta del servidor. Revisa la conexión y vuelve a intentarlo.',
      sentinels: 'Correos ignorados de SuccessFactors',
      sentinelsDesc: 'Aplica ÚNICAMENTE a la sincronización con SuccessFactors. Es el texto que el origen pone en el campo de correo cuando la persona NO tiene correo. No son direcciones: se compara sólo lo anterior a la @, así que «nomail» cubre nomail@cualquier-dominio. Si quitas una entrada, ese texto pasará a guardarse como una dirección real: quien lo traiga contará como corporativo, dejará de poder registrarse, y la corrida puede fallar por correo duplicado.',
      sentinelsHint: 'Uno por línea. Puedes pegar direcciones completas: se guardará sólo la parte anterior a la @.',
      sentinelsCount: '{{n}} entradas',
      sentinelBadFormat: 'no parece un nombre de correo válido (revisa espacios o caracteres raros)',
      sentinelNormalized: 'se guardará como «{{valor}}», así que cubrirá ese nombre con CUALQUIER dominio',
      sentinelsRemovedWarning: 'Ese texto volverá a guardarse como una dirección real. Si dos personas lo comparten, la corrida fallará por correo duplicado.',
      sentinelsAddedWarning: 'Quien traiga ese texto pasará a contar como «sin correo» y deberá registrarse.',
      sentinelsSaved: 'Lista de correos ignorados guardada.',
      sentinelsEmpty: 'La lista no puede quedar vacía: sin ninguna entrada, los correos marcadores del origen se guardarían como direcciones reales y la corrida fallaría.',
    },
  },
  monitor: {
    title: 'Monitoreo de Pipeline',
    subtitle: 'Auditoría de elegibilidad por reunión: reglas evaluadas, participantes excluidos y muestreo aplicado.',
    refresh: 'Actualizar',
    loading: 'Cargando eventos…',
    lastFetch: 'Actualizado',
    timeout: 'Timeout (10s) — MeetingService no respondió.',
    unknownError: 'Error desconocido',
    empty: 'Sin eventos de pipeline. Procesa o simula una reunión para ver los registros.',
    eligible: 'Elegible',
    ineligible: 'No elegible',
    excluded: 'Excluido',
    sampled: 'Muestreado',
    samplingApplied: 'Muestreo aplicado',
    noParticipants: 'Sin detalle de participantes.',
    statTotal: 'Reuniones procesadas',
    statEligible: 'Reuniones elegibles',
    statAvgSampled: 'Promedio muestreados',
    statAvgSampledSub: 'por reunión elegible',
    statSampling: 'Muestreo aplicado',
    statSamplingSub: 'reuniones con maxPax activo',
    colMeetingId: 'Reunión ID',
    colDate: 'Fecha',
    colDuration: 'Duración',
    colEvaluated: 'Evaluados',
    colEligible: 'Elegibles',
    colSampled: 'Muestreados',
    colMaxPax: 'Muestreo',
    colResult: 'Resultado',
    colUserId: 'Usuario',
    colOu: 'OU',
    colTimezone: 'Timezone',
    colToday: 'Hoy',
    colWeek: 'Semana',
    colInterval: 'Intervalo',
    colStatus: 'Estado',
    colReason: 'Razón',
    colSample: 'Encuesta',
    instancesTitle: 'Encuestas asignadas',
    instancesBtnTitle: 'Ver encuestas de este participante',
    instancesLoading: 'Cargando encuestas…',
    instancesEmpty: 'Sin instancias de encuesta para este participante en esta reunión.',
    instancesSurvey: 'Encuesta',
    instancesStatus: 'Estado',
    instancesExpires: 'Expira',
    instancesDownload: 'Descargar JSON',
    instancesClose: 'Cerrar',
    sortAsc: 'Ordenar ascendente',
    sortDesc: 'Ordenar descendente',
    recalculate: 'Recalcular respuestas',
    recalculateTitle: 'Recalcular conteo de respuestas en todas las encuestas',
    recalculateSuccess: 'Recálculo completado: {{count}} encuesta(s) actualizadas.',
    recalculateError: 'Error al recalcular respuestas.',
    cacheTitle: 'Caché del catálogo de OUs',
    cacheLoading: 'Consultando caché…',
    cacheError: 'No se pudo obtener el estado de la caché de OUs.',
    cachePopulated: 'Poblada',
    cacheNotPopulated: 'No poblada',
    cacheOuCount: 'OUs en caché',
    cacheLastSynced: 'Última sincronización',
    cacheNeverSynced: 'Nunca sincronizado',
  },
  trace: {
    title: 'Trazabilidad del pipeline',
    subtitle: 'Recorrido completo de una reunión, del cierre de la llamada al envío de la notificación.',
    filterModeLabel: 'Buscar por',
    filterModeSubject: 'Nombre de reunión',
    filterModeEmail: 'Correo',
    filterPlaceholderSubject: 'Ej.: Daily de plataforma',
    filterPlaceholderEmail: 'Ej.: nombre.apellido@sigma.com',
    search: 'Buscar',
    searching: 'Buscando…',
    clear: 'Limpiar',
    initialHint: 'Elige un modo de búsqueda y escribe un término para ver la trazabilidad.',
    invalidEmail: 'Escribe un correo válido.',
    requestError: 'No se pudo obtener la trazabilidad. Intenta de nuevo.',
    retry: 'Reintentar',
    download: 'Descargar traza (JSON)',
    notFoundEmailNotRegistered: 'Ese correo no está registrado como usuario. Revisa la sincronización con Azure AD.',
    notFoundUserWithoutMeetings: 'El usuario existe, pero no participó en ninguna reunión registrada.',
    notFoundSubjectNoMatches: 'Ninguna reunión coincide con ese nombre.',
    notFoundMeetingNotFound: 'La reunión ya no existe.',
    notFoundUserDirectoryUnavailable: 'No se pudo consultar el directorio de usuarios. Verifica si UserAdminService está disponible.',
    matchesTitle: 'Varias reuniones coinciden — elige una',
    matchesSubject: 'Reunión',
    matchesOrganizer: 'Organizador',
    matchesStatus: 'Estado',
    matchesStarted: 'Inicio',
    matchesEnded: 'Fin',
    meetingSummary: 'Reunión',
    meetingCorrelation: 'CorrelationId',
    meetingDuration: 'Duración',
    meetingStatus: 'Estado',
    warningsTitle: 'Avisos',
    stagesTitle: 'Etapas del pipeline',
    stageColOrder: '#',
    stageColName: 'Etapa',
    stageColService: 'Servicio',
    stageColTime: 'Hora',
    stageColOutcome: 'Resultado',
    stageMeetingEnd: 'Fin de reunión',
    stageMeetingEligibility: 'Elegibilidad de la reunión',
    stageParticipantEligibility: 'Elegibilidad de participantes',
    stageSurveyCreation: 'Creación de encuestas',
    stageNotification: 'Notificaciones',
    outcomeOk: 'OK',
    outcomeError: 'Error',
    outcomeNotEligible: 'No elegible',
    outcomeNoData: 'Sin datos',
    logsTitle: 'Log crudo correlacionado',
    logsSubtitle: 'Entradas de MeetingService, SurveyService, AnalyticsService y Bot. NotificationService no persiste log crudo.',
    logsEmpty: 'Sin entradas de log para esta reunión. El TTL de app_logs es de 24 horas.',
    logsFilterAll: 'Todos',
    logsFilterWarning: 'Warning y superior',
    logsFilterError: 'Solo errores',
    logsColTime: 'Hora',
    logsColService: 'Servicio',
    logsColLevel: 'Nivel',
    logsColMessage: 'Mensaje',
  },
  system: {
    title: 'Diagnóstico del Sistema',
    subtitle: 'Estado en tiempo real de todos los microservicios y workers del backend.',
    refreshAll: 'Actualizar todo',
    refresh: 'Actualizar',
    lastChecked: 'Última verificación',
    checking: 'Verificando…',
    never: 'Nunca',
    statusHealthy: 'Saludable',
    statusDegraded: 'Degradado',
    statusError: 'Error de conexión',
    showDetails: 'Ver checks',
    hideDetails: 'Ocultar checks',
    legendTitle: 'Glosario de estados',
    legendHealthyDesc: 'Todos los checks internos del servicio respondieron correctamente.',
    legendDegradedDesc: 'El servicio responde pero MongoDB, Redis o Service Bus reportaron error.',
    legendErrorDesc: 'No se pudo alcanzar el servicio desde el frontend (timeout, CORS o servicio caído).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Suscripciones',
    activeMessages: 'Mensajes activos',
    deadLetterMessages: 'Dead Letter',
    environment: 'Entorno',
    version: 'Versión',
    workers: 'Workers',
    workersDesc: 'Estado inferido desde las suscripciones de Service Bus.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Sin estadísticas de suscripción disponibles.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Error',
  },
  analytics: {
    title: 'Dashboard Ejecutivo',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Sesgos',
    omissions: 'Omisiones',
    personal: 'Personal',
    score: 'Score',
    responses: 'Respuestas',
    participants: 'Participantes',
    period: 'Período',
    ou: 'Unidad Organizacional',
    noData: 'Sin datos suficientes',
    completionRate: 'Completitud',
    avgByCategory: 'Promedio por categoría',
    organization: 'Organización',
    fundamentalsRadar: 'Radar de fundamentales',
    heatmapOuFund: 'Mapa de calor — Score por unidad organizacional y fundamental',
    moduleInDev: 'Módulo en desarrollo',
    executiveSubtitle: 'vista ejecutiva',
    exec: {
      periodAll: 'Todo el histórico',
    },
    tabs: {
      summary: 'Resumen',
      fundamentals: 'Fundamentales',
      heatmap: 'Mapa de Calor',
      orgNetwork: 'Red Organizacional',
      generational: 'Generacional',
    },
    noScopeTitle: 'Sin unidades organizacionales asignadas',
    noScopeDesc: 'Tu cuenta no tiene unidades organizacionales asignadas, así que no hay reportes que mostrar. Solicita al administrador central que configure tu alcance.',
    filterBar: {
      allOrg: 'Toda la organización',
      allMyScope: 'Todo mi alcance',
      allBU: 'Todas las BUs',
      allDept: 'Todos los Depts',
      allDimensions: 'Todos los comportamientos',
      clearFilters: 'Limpiar filtros',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
    },
    dimensionFilter: {
      partialScope: 'Filtrado por «{{dimension}}». La tasa de respuesta, los evaluadores, las encuestas por día y las omisiones no se desglosan por comportamiento: corresponden a todo el alcance.',
      notApplicable: 'Este bloque no se desglosa por comportamiento: se muestra sin el filtro «{{dimension}}».',
    },
    kpi: {
      evaluatedPeople_one: '{{count}} persona evaluada',
      evaluatedPeople_other: '{{count}} personas evaluadas',
      responseRateSub: 'de las encuestas ya cerradas',
      evaluations: 'Evaluaciones',
      avgScore: 'Score Promedio',
      responseRate: 'Tasa Respuesta',
      avgPerDay: 'Promedio / Día',
      evaluators: 'Evaluadores',
      scale: 'escala 1–4',
      noObservables: 'no observables',
      perDay: 'encuestas por día',
      activeParticipants: 'participantes activos',
      ofTotal: 'totales',
    },
    summary: {
      evaluationsCount_one: '{{count}} evaluación',
      evaluationsCount_other: '{{count}} evaluaciones',
      behaviorPositioningDesc: 'Ranking por comportamiento; los fundamentales sin comportamientos configurados se muestran completos',
      behaviorColumn: 'Comportamiento',
      distribution: 'Distribución',
      omittedSurveys: 'Omitidas',
      topBehaviors: 'Top Daily Habits',
      topDailyHabitsSubtitle: 'Hábitos con mayor impacto en cultura',
      oppSubtitle: 'Hábitos con mayor área de mejora',
      opportunities: 'Áreas de Oportunidad',
      omissionsByUnit: 'Omisiones por Unidad',
      omissionsSubtitle: 'Tasa de omisión por OU y BU — ordenadas de mayor a menor · Haz clic en una OU para ver sus BUs',
      downloadExcel: 'Descargar Excel',
      omitType: 'Tipo',
      omitPeople: 'Personas',
      omitRate: 'Tasa Omisión',
      noOmissions: 'Sin omisiones significativas',
      percentileDistribution: 'Distribución por Percentil',
      percentileSubtitle: 'Qué porcentaje de la población cae en cada rango de score',
      personsEvaluated: 'personas evaluadas',
      excellent: 'Excelente',
      good: 'Bueno',
      developing: 'En desarrollo',
      attention: 'Atención',
      fundPositioning: 'Posicionamiento Fundamentales',
      fundPositioningDesc: 'Ranking, mayor/menor puntaje y tasa de no observable por fundamental',
      highestScore: 'Mayor puntaje',
      lowestScore: 'Menor puntaje',
      mostNoObs: 'Mayor No Observable',
      scoreByOU: 'Score por Unidad Organizacional',
      scoreByOUSubtitle: 'Haz clic en una OU para ver el desglose por BU y Departamento',
      person: 'persona',
      persons: 'personas',
    },
    fundamentals: {
      behaviorSubtitle: 'Cada fundamental se desglosa en sus comportamientos; expande uno para ver sus daily habits',
      noObsCount_one: '{{count}} encuesta no lo evaluó',
      noObsCount_other: '{{count}} encuestas no lo evaluaron',
      dailyHabits: 'Daily habits',
      title: 'Score por Fundamental',
      subtitle: 'Expande cada fundamental para ver sus daily habits y desglose por OU',
      evalLabel: 'eval',
      confPreliminary: 'Dato preliminar',
      confBasedOn: 'Basado en {{n}} eval',
    },
    heatmap: {
      behaviorSubtitle: 'Puntaje por unidad organizacional y comportamiento; toca cualquier fila para explorar sus sub-unidades',
      directlyAssigned: 'Asignados a {{ou}}',
      hideEmpty_one: 'Ocultar {{count}} unidad sin datos',
      hideEmpty_other: 'Ocultar {{count}} unidades sin datos',
      personCount_one: '{{count}} persona',
      personCount_other: '{{count}} personas',
      title: 'Mapa de Calor Cultural',
      subtitle: 'Toca cualquier fila para explorar sus sub-unidades',
      unit: 'Unidad',
      unitOU: 'Unidad Organizacional',
      unitBU: 'Business Unit',
      unitDept: 'Departamento',
      unitPerson: 'Responsable',
      allOrg: 'Toda la organización',
      hint: 'Toca cualquier fila para explorar el nivel siguiente →',
      person: 'persona',
      persons: 'personas',
      legendCritical: 'Crítico',
      legendLow: 'Bajo',
      legendMedium: 'Medio',
      legendGood: 'Bueno',
      legendExcellent: 'Excelente',
      noOu: 'Sin OU',
    },
    ona: {
      directlyAssigned: 'Asignados directamente',
      collaboratorsCount_one: '{{count}} colaborador',
      collaboratorsCount_other: '{{count}} colaboradores',
      typeBu: 'BU',
      typeDept: 'Depto.',
      typePerson: 'Persona',
      title: 'Red Organizacional (ONA)',
      subtitle: 'Árbol interactivo de unidades organizacionales (OU)',
      treeHint: 'Expande cada nodo para navegar los niveles de OU de la organización.',
      omissions: 'Omisiones',
      totalPeople: 'Personas',
      avgScore: 'Score promedio',
      totalEvals: 'Total evaluaciones',
      collaboratorsKpi: 'Colaboradores',
      highestOmission: 'Mayor omisión',
      omissionsRanking: 'Ranking de omisiones',
      maturityCulture: 'Madurez cultural',
      maturityLegend: 'Leyenda de madurez',
      maturityInitial: 'Inicial',
      maturityGrowing: 'En desarrollo',
      maturityConsolidated: 'Consolidado',
      maturityRoleModel: 'Role Model',
      evalsLabel: 'evaluaciones',
      noEvals: 'Sin evaluaciones',
      collaboratorsLabel: 'colaboradores',
      omissionLabel: 'omisión',
      evalsShort: 'evals',
      omittedCount_one: '{{count}} omitida',
      omittedCount_other: '{{count}} omitidas',
    },
    gen: {
      personasCount_one: '{{count}} persona',
      personasCount_other: '{{count}} personas',
      panorama: 'Panorama',
      ranking: 'Ranking',
      brechas: 'Brechas',
      avgAge: 'Edad promedio',
      title: 'Análisis Generacional',
      subtitle: 'Distribución y madurez cultural por cohorte · {{n}} personas mapeadas',
      noRepresentation: 'Sin representación',
      scoreLabel: 'Score',
      omissionLabel: 'Omisión',
      personas: 'personas',
      age: 'Edad',
      all: 'Todos',
      noData: 'Sin datos para este filtro',
      fundamental: 'Fundamental',
      gapCol: 'Δ Brecha',
      brechaNote: 'Brecha mayor: {{fund}} · Δ {{delta}} pts entre generaciones',
      brechaSource: 'Diferencia vs. el promedio general del fundamental en la organización',
      responseCount: '{{n}} respuestas',
    },
  },
  userConfig: {
    fabTitle: 'Configurar perfil de usuario',
    title: 'Perfil de usuario (demo)',
    subtitle: 'Modo pruebas — simula los datos que se recibirán de Teams SSO al integrar con el back-end',
    nombre: 'Nombre',
    correo: 'Correo electrónico',
    ou: 'OU (Unidad Organizacional)',
    do_: 'DO (Dirección / División)',
    bu: 'BU (Unidad de Negocio)',
    departamento: 'Departamento',
    puesto: 'Puesto',
    numeronomina: 'Número de nómina',
    role: 'Rol',
    roleDetected: 'Rol detectado',
    roleNotFound: 'Correo no encontrado en usuarios — se usará Empleado',
    save: 'Guardar perfil',
    namePlaceholder: 'Ej: Ana García',
    emailPlaceholder: 'Ej: agarcia@sigma.com',
    ouPlaceholder: 'Ej: Tecnología',
    doPlaceholder: 'Ej: Dirección de Tecnología',
    buPlaceholder: 'Ej: México',
    deptPlaceholder: 'Ej: Desarrollo de Software',
    puestoPlaceholder: 'Ej: Ingeniero de Software Sr.',
    nominaPlaceholder: 'Ej: 123456',
    fechaNacimiento: 'Fecha de nacimiento',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'Ocurrió un error inesperado',
    unauthorized: 'No tienes permisos para esta acción',
    notFound: 'Recurso no encontrado',
    network: 'Error de conexión. Verifica tu red.',
  },
  fundamentals: {
    title: 'Fundamentales',
    subtitle: 'Los comportamientos que medimos en Sigma. Abre uno para ver sus hábitos diarios.',
    habitsFor: 'Hábitos diarios',
    otherHabits: 'Otros hábitos',
    openHabits: 'Ver hábitos diarios de {{name}}',
    openMicrosite: 'Abrir micrositio de {{name}}',
  },
};

export default es;

